import { useEffect, useRef } from 'react';
export function doesElementContain(source, target) {
    if (!source || !target)
        return false;
    return source.contains(target);
}
export function useOutsideClick(refs, cb) {
    const callback = useRef(cb);
    useEffect(() => {
        callback.current = cb;
    }, [cb]);
    useEffect(() => {
        const handleClick = (e) => {
            const isOutside = (() => {
                if (Array.isArray(refs)) {
                    return refs.reduce((acc, ref) => {
                        if (!ref || acc === false)
                            return acc;
                        return !doesElementContain(ref.current ?? undefined, e.target);
                    }, true);
                }
                return !doesElementContain(refs.current ?? undefined, e.target);
            })();
            if (isOutside)
                callback.current(e);
        };
        document.addEventListener('pointerdown', handleClick);
        return () => {
            document.removeEventListener('pointerdown', handleClick);
        };
    }, [refs]);
}
//# sourceMappingURL=useOutsideClick.js.map